<div class="loginClass" style="height: 80%;" fxLayout= "column" fxLayoutAlign="center space-evenly">
    <div fxLayout="row">
       <mat-card style="padding: 0px;" fxFlexOffset.xs="5%" fxFlexOffset="33%" fxFlex.xs = "90%" fxFlex.sm="100%" fxFlex="33%"> 
           <form [formGroup] = "loginForm">
                   <mat-toolbar color="primary">
                       <mat-toolbar-row>
                            <h3 style="color:white">Sign in</h3>
                       </mat-toolbar-row>
                   </mat-toolbar>
                   <mat-card-content fxLayout="column">
                   <mat-form-field style="padding-left: 10px;">
                       <mat-label>User Id</mat-label>
                       <input maxlength="12" size="12" type="text" matInput formControlName="referenceId" placeholder="User Id">
                   </mat-form-field>
                   <mat-form-field style="padding-left: 10px;">
                       <mat-label>Password</mat-label>
                       <input size="30" type="password" formControlName="password" matInput placeholder="Password">
                   </mat-form-field>                
               </mat-card-content>
               <mat-card-actions style="padding-left:20px;padding-right: 20px;padding-bottom: 10px;">
                   <div fxFlex></div>
                   <button type="submit"  [disabled]="!loginForm.valid" mat-raised-button color="primary" (click)="submit()">Login</button>
               </mat-card-actions>
           </form>
       </mat-card>
   </div>
</div>

